import Quiz from './components/Quiz/Quiz';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import posterDefault from './assets/images/bgPoster.png';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import { useCarousel } from './hooks/useCarousel';

import { MessagesList } from './components/MessagesList/MessagesList';
import { motion, AnimatePresence } from 'motion/react';

import { useEffect, useMemo, useRef, useState } from 'react';

import bgPoster1 from './assets/images/bgPoster1.png';
import bgVideo1 from './assets/video/bgVideo1.webm';

import snow from './assets/video/snow.webm';
import Advt from './components/Advt/Advt';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, winnerMessage, speed, mode, keyWinner } =
    useCarousel(currentState);

  const { marginTopQuiz, questionFontSize, authorFontSize } = useGetParams();

  const videoRef = useRef(null);
  const [prevState, setPrevState] = useState(null);

  const animateState = useMemo(() => {
    if (currentState === 'S1') {
      return 'advt';
    } else if (['S2', 'S3'].includes(currentState)) {
      return 'quiz';
    } else if (['S4', 'S5', 'S6', 'S7'].includes(currentState)) {
      return 'messages';
    } else return null;
  }, [currentState]);

  useEffect(() => {
    if (!prevState) {
      setPrevState(animateState);
    }
    if (prevState && animateState !== prevState && videoRef.current) {
      videoRef.current.play();
      setPrevState(animateState);
    }
  }, [animateState]);

  // задержка на время перехода между стадиями (видео со снежинкой)
  const delayTransition = prevState ? 0.7 : 0;

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="sync">
        {currentState === 'S1' && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: delayTransition } }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            key="advt"
            className="motionBlock"
          >
            <AdvtFullSize delayTransition={delayTransition} />
          </motion.div>
        )}

        {['S2', 'S3'].includes(currentState) && (
          <motion.div
            key="quiz"
            className="motionBlock"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: delayTransition } }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <Advt />
            <Quiz
              delayTransition={delayTransition}
              variants={voteState?.vars}
              title={voteState?.title}
              questionImgUrl={voteState?.questionImgUrl}
              currentState={currentState}
              marginTopQuiz={marginTopQuiz}
              idVote={voteState?.id}
              questionFontSize={questionFontSize}
            />
          </motion.div>
        )}

        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <motion.div
            key="messageList"
            className="motionBlock"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: delayTransition } }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <MessagesList
              mode={mode}
              delayTransition={delayTransition}
              key="msgList"
              winId={winnerMessage?.[keyWinner]}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              currentState={currentState}
              speed={speed || 0}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="sync">
        {(!currentState || ['S1', 'S2', 'S3'].includes(currentState)) && (
          <motion.div
            key="bgvideo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <video
              playsInline
              autoPlay="autoplay"
              muted="muted"
              loop
              id="bgVideo"
              poster={posterDefault}
            >
              <source src={bgDefaultVideo} type="video/webm"></source>
            </video>
          </motion.div>
        )}
        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <motion.div
            key="snow-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <video
              playsInline
              autoPlay="autoplay"
              muted="muted"
              loop
              id="bgVideo"
              poster={bgPoster1}
            >
              <source src={bgVideo1} type="video/webm"></source>
            </video>
          </motion.div>
        )}
      </AnimatePresence>

      <video playsInline ref={videoRef} muted="muted" className="snowVideo">
        <source src={snow} type="video/webm"></source>
      </video>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
